import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import './index.scss'
import { NavigationProvider } from './contexts/navigationContext'
import { Provider } from 'react-redux'
import store from './store'
import '../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css'

ReactDOM.render(
  <Provider store={store}>
    <NavigationProvider>
      <App />
    </NavigationProvider>
  </Provider>,
  document.getElementById('root')
)
